import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { DataProvider } from "./context/DataContext";
import { ReactDevToolsProvider } from "./context/ReactDevTools";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ReactDevToolsProvider>
      <DataProvider>
        <App />
      </DataProvider>
    </ReactDevToolsProvider>
  </React.StrictMode>
);